export default class Breakpoints {
  constructor(breakpoints) {
    this.breakpoints = breakpoints || {}
    this.current = this.getCurrent()
    this.observer = {}
    this['resizeEvent'] = this['resizeEvent'].bind(this)

    this.init()
  }

  static onLazyResize(cb) {
    let timer = 0
    window.addEventListener('resize', () => {
      clearTimeout(timer)
      timer = setTimeout(() => {
        cb()
      }, 300)
    })
  }

  init() {
    this.detachEvents()
    this.attachEvents()
    Breakpoints.onLazyResize(() => {
      this.trigger('resize')
    })
  }

  attachEvents() {
    this.on('resize', this.resizeEvent)
  }

  detachEvents() {
    for (const event of Object.keys(this.observer)) {
      this.off(event)
    }
  }

  resizeEvent() {
    const before = this.current
    const after = this.getCurrent()
    if (before !== after) {
      this.trigger('change', before, after)
      this.updateCurrent(after)
    }
  }

  getCurrent() {
    const last = arr => arr[arr.length - 1]
    return last(Object.keys(this.breakpoints).filter(name => this.breakpoints[name] <= window.innerWidth))
  }

  isCurrent(name) {
    if (!this.breakpoints.hasOwnProperty(name)) {
      throw new Error(`Breakpoint \`${name}\` not defined`)
    }
    return name === this.getCurrent()
  }

  updateCurrent(after) {
    this.current = after
  }

  on(event, listener) {
    if (!this.observer[event]) {
      this.observer[event] = []
    }
    this.observer[event].push(listener)
  }

  off(event) {
    if (!this.observer[event]) return
    this.observer[event] = []
  }

  trigger(event, ...args) {
    if (!this.observer[event]) return
    for (const f of this.observer[event]) {
      f(...args)
    }
  }
}
